import MCheckbox from '@assets/mui/@material-extend/MCheckbox';
import HiddenContent from '@components/UI/HiddenContent';
import { FormControlLabel } from '@material-ui/core';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { FilterData } from '@services/requests/routeCalculator/routesCalculationService/interfaces';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Container from './StyledComponents';
import { AlternativeVariantsFilterProps } from './types';

const AlternativeVariantsFilter = <T extends keyof FilterData['alternativeRoutes']>({
  handleChangeFilterValue,
  handleResetAlternativeVariants,
  values,
  name,
  variants,
}: AlternativeVariantsFilterProps) => {
  const { t } = useTranslation(['RoutesListComponent']);

  const items: { value: T; title: React.ReactNode }[] = Object.keys(variants).map((item: T) => ({
    value: item,
    title: t('RoutesListComponent:AlternativeVariants.Variants.' + item),
  }));

  return (
    <HiddenContent title={name} defaultVisibility onReset={() => handleResetAlternativeVariants()}>
      <Container>
        {items.map((item, index) => {
          const checked = values[item.value];
          return (
            <FormControlLabel
              key={`checkbox-grid--${item.value}`}
              disabled={!variants[item.value]}
              control={
                <MCheckbox
                  size="small"
                  checked={checked}
                  onChange={() => handleChangeFilterValue(item.value, !checked)}
                  sx={{
                    padding: '0 5px 0 0',
                    borderColor: '#CFD5E2',
                  }}
                />
              }
              label={
                <>
                  <span>
                    <Tooltip
                      placement="top"
                      title={
                        <div
                          dangerouslySetInnerHTML={{
                            __html: `<p><b>${t(
                              'RoutesListComponent:AlternativeVariants.AlertDetailsCommon.Items.' +
                                item.value +
                                '.Name'
                            )}</b> ${t(
                              'RoutesListComponent:AlternativeVariants.AlertDetailsCommon.Items.' +
                                item.value +
                                '.Tooltip'
                            )}</p>`,
                          }}
                          className="a-html-content"
                        />
                      }
                    >
                      <IconButton
                        sx={{
                          width: 16,
                          height: 16,
                          backgroundColor: '#E9FCD4',
                          marginBottom: '2px',
                        }}
                      >
                        <QuestionMarkIcon sx={{ fontSize: 8, color: '#707070' }} />
                      </IconButton>
                    </Tooltip>
                  </span>
                  <span>{item.title}</span>
                </>
              }
              sx={{
                '& .MuiTypography-root': {
                  fontSize: 12,
                  fontWeight: 500,
                  color: '#22262D',
                },
                '& .MuiCheckbox--description': {
                  fontSize: 10,
                  fontWeight: 500,
                  color: '#6C7484',
                },
              }}
            />
          );
        })}
      </Container>
    </HiddenContent>
  );
};

export default AlternativeVariantsFilter;
